module.exports = __webpack_public_path__ + "assets/ai-role-play-active.8dbff602.svg";